/** Must match backend Auth:Cookies names. */
export const AuthCookies = {
  csrfCookieName: 'crowpeaks.csrf',
  csrfHeaderName: 'X-CSRF-TOKEN',
} as const;
